<template>
  <div id="parameters">
    <h1 class="text-center">{{ $t('pages.parameter.long_title') }}</h1>
    <b-container v-if="get().oauth">
      <timeline
        v-if="step !== 0"
        :current-step="step"
        :total-step="5"
      />
      <template v-if="step === 1">
        <memorial-new/>
      </template>
      <template v-else-if="step === 2">
        <manager-edit/>
      </template>
      <template v-else-if="step === 3">
        <memorial-security
          :is-private="isPrivate"
        />
      </template>
      <template v-else-if="step === 4">
        <memorial-promo/>
      </template>
      <template v-else-if="step === 5">
        <memorial-payment/>
      </template>
      <template v-else>
        <b-card no-body class="mb-1">
          <b-card-header
            header-tag="header"
            class="p-1"
            role="tab"
          >
            <b-btn
              v-b-toggle.accordion1
              block
              href="#"
              class="text-left"
              variant="light"
            >
              {{ $t('pages.memorial.edit') }}
            </b-btn>
          </b-card-header>
          <b-collapse
            id="accordion1"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <memorial-edit/>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header
            header-tag="header"
            class="p-1"
            role="tab"
          >
            <b-btn
              v-b-toggle.accordion2
              block
              href="#"
              class="text-left"
              variant="light"
            >
              {{ $t('pages.manager.edit') }}
            </b-btn>
          </b-card-header>
          <b-collapse
            id="accordion2"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <manager-edit/>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header
            header-tag="header"
            class="p-1"
            role="tab"
          >
            <b-btn
              v-b-toggle.accordion3
              block
              href="#"
              class="text-left"
              variant="light"
            >
              {{ $t('pages.memorial.accessibility') }}
            </b-btn>
          </b-card-header>
          <b-collapse
            id="accordion3"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <memorial-accessibility/>
            </b-card-body>
          </b-collapse>
        </b-card>
        <b-card no-body class="mb-1">
          <b-card-header
            header-tag="header"
            class="p-1"
            role="tab"
          >
            <b-btn
              v-b-toggle.accordion4
              block
              href="#"
              class="text-left"
              variant="light"
            >
              {{ $t('pages.memorial.security') }}
            </b-btn>
          </b-card-header>
          <b-collapse
            id="accordion4"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <memorial-security
                :is-private="isPrivate"
              />
            </b-card-body>
          </b-collapse>
        </b-card>
      </template>
    </b-container>
  </div>
</template>

<script>
  import MemorialNew from '@/views/Memorial/new';
  import MemorialEdit from '@/views/Memorial/edit';
  import ManagerEdit from '@/views/Manager/edit';
  import MemorialSecurity from '@/views/Memorial/security';
  import MemorialAccessibility from '@/views/Memorial/accessibility';
  import MemorialPayment from '@/views/Memorial/payment';
  import MemorialPromo from '@/views/Memorial/promo';
  import Timeline from '@/components/Timeline';

  export default {
    name: 'Parameter',
    components: {
      MemorialNew,
      MemorialEdit,
      ManagerEdit,
      MemorialSecurity,
      MemorialAccessibility,
      MemorialPayment,
      MemorialPromo,
      Timeline,
    },
    data() {
      return {
        step: this.calculateStep(),
        isPrivate: false,
      };
    },
    async mounted() {
      if (this.user() && this.user().memorial) {
        this.entity = await this.getMemorial();
        this.isPrivate = this.entity.private_password !== null && this.entity.private_password !== null;
        this.set({ memorial: this.entity });

        this.$bus.$emit('t-event.get-memo.stored', this.entity);
      }
      this.$bus.$on('t-event.change-private', () => {
        this.isPrivate = !this.isPrivate;
      });
      window.$(document).on('click', 'button[type="submit"]', () => {
        window.$('html, body').animate({ scrollTop: 0 }, 0);
      });
    },
    methods: {
      calculateStep() {
        if (this.get().oauth) {
          const { user } = this.get().oauth;
          // console.log("this is user that we got from get oauth : ", user)
          if (!user.memorial) {
            return 1;
          } else if (!user.last_name) {
            return 2;
          } else if (!user.memorial.currency) {
            return 3;
          } else if (user.memorial.promotional_code === undefined && user.memorial.subscribed !== true && _.size(user.memorial.subscriptions) === 0 && user.roles[0] !== 'ROLE_ADMIN') {
            return 4;
          }
        }
        return 0;
      },
      async getMemorial() {
        const identifier = this.get().oauth.user.memorial.id;
        let memorial;
        await this.$ajax.get(`api/memorial/${identifier}`).then((memo) => {
          memorial = memo;
          this.$bus.$emit('t-event.get-memo.success', memorial);
        });

        return memorial;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  h1 {
    margin-top: 20px;
    margin-bottom: 30px;
  }

  /deep/ h2 {
    margin-left: 15px;
    margin-top: 10px;
    margin-bottom: 25px;
    font-size: 1.5rem !important;
  }

  @include editable-max-width(480px) {
    .card-header {
      a.btn {
        white-space: unset;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Parameter/edit.vue